module.exports = __webpack_public_path__ + "img/goldregen-2020-067.e45e488e.jpg";